import type { KeyAttentionDto } from '@nsb/core';
import { Link } from 'react-router';
import { useApi } from '../api.ts';

/**
 * For admins, above the header: a connected account the nightly check found
 * not working, said in words with the way to renew it (Jason, 2026-10-03:
 * "a check every day at midnight that the key is still valid and then it asks
 * me to renew").
 */
export function KeyNotice() {
  const { data } = useApi<KeyAttentionDto[]>(['integrations', 'attention'], '/integrations/attention');
  if (!data?.length) return null;
  return (
    <div className="border-b border-rule bg-sheet" role="status">
      <ul className="shell py-2">
        {data.map((k) => (
          <li key={k.provider} className={`text-[0.9375rem] ${k.urgent ? 'text-alert' : 'text-ink-2'}`}>
            {k.words}{' '}
            <Link to="/settings/connections" className="link whitespace-nowrap">
              {k.renew === 'key' ? 'Renew it in Settings' : 'Connect it again in Settings'}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
